import React from "react";

import { Icon } from "@cobasi/ds-icons";
import Xmark from "@cobasi/ds-icons/solid/xmark";

import type { SnackbarProps } from "./snackbar.types";

import s from "./snackbar.module.scss";

const Snackbar = ({
  show,
  message,
  theme = "dark",
  fixed,
  variant,
  color,
  actionText,
  onCloseButton,
  onActionButton,
  longerAction,
  position = "center",
  customStyles = {}
}: SnackbarProps) => {
  const positionStyles: React.CSSProperties = {
    ...(position === "left" && { left: "3.2rem", transform: "none" }),
    ...(position === "right" && {
      right: "3.2rem",
      transform: "none",
      left: "unset"
    })
  };

  const showClass = show ? " show" : "";
  const themeClass = theme === "dark" ? " snackbar-dark" : "";
  const fixedClass = fixed ? ` snackbar-fixed` : "";
  const variantClass = variant ? ` ${variant}` : "";
  const colorClass = color ? ` snackbar-${color}` : "";
  const longerActionClass = longerAction ? " snackbar-longeraction" : "";

  const showActionButton = !!onActionButton && !!actionText;

  return (
    <div
      className={`snackbar${longerActionClass}${variantClass}${colorClass}${fixedClass}${themeClass}${showClass} ${s["snackbar-wrapper"]}`}
      style={{
        ...positionStyles,
        ...customStyles
      }}
    >
      <span className={`snackbar-text ${s["snackbar-text"]}`}>{message}</span>
      {showActionButton && (
        <button
          onClick={onActionButton}
          type="button"
          className="snackbar-actiontext"
        >
          {actionText}
        </button>
      )}
      {onCloseButton && (
        <button
          onClick={onCloseButton}
          type="button"
          className="snackbar-closebutton"
          aria-label="Fechar"
        >
          <Icon icon={Xmark} width="1.2rem" height="1.6rem" />
        </button>
      )}
    </div>
  );
};

export default Snackbar;
